export const matchAnyInArray = (string?: string, array?: string[]) => {
  return array?.some((s) => s === string);
};
